import SearchInput from "../../../components/inputs/searchInput";
import { useFormik } from "formik";
import SearchSelect from "../../../components/select/searchSelect";
import { useOptions } from "../../../components/hooks/useOptionsHook";

const SearchEmployees = ({ t }) => {
  const formik = useFormik({ initialValues: {} });
  const { employeesStatusOptions } = useOptions();

  return (
    <section className="flex flex-wrap items-center justify-between gap-3 md:flex-nowrap">
      <div className="flex flex-wrap items-center w-full gap-3 md:w-1/3 md:flex-nowrap">
        <div className="flex-1">
          <SearchInput
            formik={formik}
            name={"search"}
            placeholder={t("searchWithNameOrDepartment")}
          />
        </div>
        <div className="w-full md:w-auto">
          <SearchSelect
            options={employeesStatusOptions}
            formik={formik}
            name={"status"}
            placeholder={t("status")}
          />
        </div>
      </div>
      <div className="w-full md:w-auto">
        <SearchSelect
          options={employeesStatusOptions}
          formik={formik}
          name={"download"}
          placeholder={t("downloadFile")}
        />
      </div>
    </section>
  );
};

export default SearchEmployees;
